import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { Badge } from "V2.0/common/badge";
import Pagination from "V2.0/components/Pagination";

import { formatTime } from "V2.0/utils";
import { TrashIcon } from "@heroicons/react/24/outline";

import {
  PipelineV2RunStatusBadgeRegistry,
  renderDefaultBadge,
} from "./PipelineV2RunStatusBadge";

export default PipelineV2RunsList;

interface PipelineV2RunsListProps {
  pipelineRuns: Array<any>;
  pagination: {
    page: number;
    pageSize: number;
    totalRuns: number;
    totalPages: number;
  };
  onPipelineRunClick: (pipelineRun: any) => void;
  onPipelineRunDelete: (pipelineRun: any) => void;
  onPageChange: (page: number) => void;
}

function PipelineV2RunsList(props: PipelineV2RunsListProps) {
  const {
    pipelineRuns,
    pagination,
    onPipelineRunClick,
    onPipelineRunDelete,
    onPageChange,
  } = props;

  return (
    <div className="flex-1 flex flex-col h-full">
      <div className="flex-1 h-full overflow-auto">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Phone</TableHeader>
              <TableHeader>Created At</TableHeader>
              <TableHeader>Status</TableHeader>
              <TableHeader>Current Step</TableHeader>
              <TableHeader>Action</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {pipelineRuns.map((pipelineRun) => {
              const {
                _id,
                userIdentifier,
                createdAt,
                currentNodeId,
                status,
                pipelineSnapshot,
              } = pipelineRun;

              const statusBadge =
                PipelineV2RunStatusBadgeRegistry[status] ??
                renderDefaultBadge(status);
              const currentNodeName = pipelineSnapshot.nodes.filter(
                (node) => node.nodeId === currentNodeId,
              )[0];

              const handleDelete = (e) => {
                e.stopPropagation();
                onPipelineRunDelete(pipelineRun);
              };

              const handleRowClick = (e) => {
                e.stopPropagation();
                onPipelineRunClick(pipelineRun);
              };

              return (
                <TableRow
                  className="hover:cursor-pointer hover:bg-gray-50"
                  key={_id}
                  onClick={handleRowClick}
                >
                  <TableCell>{userIdentifier}</TableCell>
                  <TableCell>{formatTime(createdAt)}</TableCell>
                  <TableCell>{statusBadge}</TableCell>
                  <TableCell>
                    {currentNodeName ? (
                      <Badge color="purple">
                        {currentNodeName.config.name}
                      </Badge>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell>
                    <Button
                      outline
                      onClick={handleDelete}
                    >
                      <TrashIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>

      <Pagination
        currentPage={pagination.page}
        totalItems={pagination.totalRuns}
        itemsPerPage={pagination.pageSize}
        onPageChange={onPageChange}
      />
    </div>
  );
}
